import React, { FunctionComponent, useMemo } from 'react';
import DisclaimerSection from './DisclaimerSection';
import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../store/selectors/carConfigurationSelectors';
import currentDealSelectors from '../../../store/selectors/currentDealSelectors';
import { useIntl } from 'react-intl';
import useFinanceDisclaimers from '../../../react/disclaimers/useFinanceDisclaimers';

const DisclaimerContainer: FunctionComponent = () => {
  const intl = useIntl();
  const disclaimers: string[] = useSelector(carConfigurationSelectors.getDisclaimers)?.general || [];
  const colourDisclaimer: string = useSelector(carConfigurationSelectors.getDisclaimers)?.colour;
  const indicativeRateContent = intl.formatMessage({
    id: 'spc.customise.disclaimer.indicativeRate.content',
    defaultMessage: '',
  });
  const indicativeRateIndicator = intl.formatMessage({
    id: 'spc.customise.disclaimer.indicativeRate.indicator',
    defaultMessage: '',
  });
  const indicativeRateDesc = intl.formatMessage({
    id: 'spc.customise.disclaimer.indicativeRate.description',
    defaultMessage: '',
  });
  const comparisonRateContent = intl.formatMessage({
    id: 'spc.customise.disclaimer.comparisonRate.content',
    defaultMessage: '',
  });
  const comparisonRateIndicator = intl.formatMessage({
    id: 'spc.customise.disclaimer.comparisonRate.indicator',
    defaultMessage: '',
  });
  const comparisonRateDesc = intl.formatMessage({
    id: 'spc.customise.disclaimer.comparisonRate.description',
    defaultMessage: '',
  });
  const { financeDisclaimers } = useFinanceDisclaimers();

  const isCash: boolean = useSelector(currentDealSelectors.getFinanceQuote)?.isCashProduct;
  const disclaimerList: string[] = useMemo(() => {
    let list = [colourDisclaimer, ...(disclaimers ?? [])] || [];
    if (!isCash) {
      list = [...list, ...financeDisclaimers];
      const displayContent = (rateIndicator: string, rateDesc: string, rateContent: string) => {
        const newList = [`${rateIndicator} ${rateDesc} ${rateContent}`];

        if (rateContent?.trim()) {
          list = [...list, ...newList];
        }
      };
      displayContent(indicativeRateIndicator, indicativeRateDesc, indicativeRateContent);
      displayContent(comparisonRateIndicator, comparisonRateDesc, comparisonRateContent);
    }

    return list;
  }, [disclaimers, financeDisclaimers, isCash, indicativeRateContent, comparisonRateContent]);

  if (disclaimerList.length === 0) {
    return null;
  }
  return <DisclaimerSection disclaimers={disclaimerList} />;
};

export default DisclaimerContainer;
